import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import moment from "moment";
import AppTable from "components/AppTable/AppTable";

const UserUsageTable = ({ adminGatewayStore, userId }) => {
  const [loadingList, setLoadingList] = useState(false);

  useEffect(() => {
    handleSync();
  }, []);

  const handleSync = async () => {
    setLoadingList(true);
    try {
      await adminGatewayStore.getUserUsageData(userId);
    } finally {
      setLoadingList(false);
    }
  };

  const columns = [
    {
      title: "Period",
      key: "period",
      width: 100,
      render: (_, record) => (
        <div className=" fw-medium">
          {moment()
            .month(record.month - 1)
            .format("MMM")}{" "}
          {record.year}
        </div>
      )
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 140,
      render: text => <div>{moment(text).format("DD/MM/YYYY ")}</div>
    },
    {
      title: "SMS Usage",
      key: "sms_usage",
      width: 120,
      render: (_, record) => (
        <div>
          <div className="fw-medium">{record.totalSms || 0} SMS</div>
          <div className="text-muted" style={{ fontSize: "11px" }}>
            ¢{record.perSmsRate?.toFixed(2) || "0.00"} each
          </div>
        </div>
      )
    },
    {
      title: "MMS Usage",
      key: "mms_usage",
      width: 120,
      render: (_, record) => (
        <div>
          <div className="fw-medium">{record.totalMms || 0} MMS</div>
          <div className="text-muted" style={{ fontSize: "11px" }}>
            ¢{record.perMmsRate?.toFixed(2) || "0.00"} each
          </div>
        </div>
      )
    },
    {
      title: "SMS Amount",
      dataIndex: "totalSmsAmount",
      key: "sms_amount",
      width: 100,
      render: text => <div className=" fw-medium text-primary">${(text / 100 || 0).toFixed(2)}</div>
    },
    {
      title: "MMS Amount",
      dataIndex: "totalMmsAmount",
      key: "mms_amount",
      width: 100,
      render: text => <div className=" fw-medium text-success">${(text / 100 || 0).toFixed(2)}</div>
    },
    {
      title: "Dedicated Amount",
      dataIndex: "dedicatedAmount",
      key: "dedicated_amount",
      width: 100,
      render: text => <div className="fw-medium text-warning">${(text || 0).toFixed(2)}</div>
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "total_amount",
      width: 120,
      render: text => <div className="bg-light text-dark fw-semibold px-2 py-1 rounded">${(text || 0).toFixed(2)}</div>
    }
  ];

  const paginationConfig = {
    defaultCurrent: 1,
    current: adminGatewayStore.usagePagination?.current || 1,
    total: adminGatewayStore.usagePagination?.total || 0,
    pageSize: adminGatewayStore.usagePagination?.pageSize || 10,
    onChange: current => adminGatewayStore.setUsagePage(current),
    showSizeChanger: true,
    onShowSizeChange: (current, pageSize) => adminGatewayStore.setUsagePageSize(pageSize),
    className: "float-start",
    hideOnSinglePage: true,
    showQuickJumper: true
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body p-3">
        <div className="row g-3">
          <div className="col-12">
            <h3 className="card-title h5 fw-bold mb-3">User Usage Data</h3>
          </div>

          <div className="col-12">
            <AppTable
              loading={loadingList}
              pagination={paginationConfig}
              columns={columns}
              dataSource={adminGatewayStore.userUsageList || []}
              scroll={{ x: 800, y: 725 }}
              secondary
              rowKey={record => record._id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject(stores => ({
  adminGatewayStore: stores.store.adminGatewayStore
}))(observer(UserUsageTable));
